import { useQuery } from "react-query";
import { getExistingTables } from "../requests/Tables";

export function useQueryExistingTables(id: number) {
  const onError = () => {
  };
  const query =
    useQuery("apiQueryExistingTables",
      async () => await getExistingTables(id), { onError });
  return query;
}